import {useMemo} from 'react';

import {serverIncidentAPI} from 'features/server/api/serverIncidentAPI';

import IServerOutput from './Server/IServer';
import IServerIncident from './ServerIncident/IServerIncident';

const HISTORY_LIMIT = 5;
const OPEN_INCIDENTS_LIMIT = 500;

export const useServerIncidentsSummary = (server: IServerOutput) => {
    const {data: openPagination, isLoading: isOpenLoading} = serverIncidentAPI.useGetServerIncidentsQuery({
        filters: [
            `server.uuid=${server.uuid}`,
            'exists[closed_at]=false',
        ],
        limit: OPEN_INCIDENTS_LIMIT,
    });
    const {data: closedPagination, isLoading: isClosedLoading} = serverIncidentAPI.useGetServerIncidentsQuery({
        filters: [`server.uuid=${server.uuid}`, 'exists[closed_at]=true'],
    });

    const items = useMemo<IServerIncident[]>(
        () => [
            ...(openPagination?.items ?? []),
            ...(closedPagination?.items ?? []).slice(0, HISTORY_LIMIT),
        ],
        [openPagination, closedPagination],
    );

    return {
        items,
        isLoading: isOpenLoading || isClosedLoading,
        unresolved: openPagination?.totalItems ?? 0,
        resolved: closedPagination?.totalItems ?? 0,
    };
};
